import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import {AzPageHeader} from '../../components/AzPageHeader'
import { ThemesListWrapper } from './themes-list/ThemesList';
import { useIntl } from 'react-intl';

const ThemesPage = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Themes'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'THEMES_PAGE.TITLE' })} />
              <ThemesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/themes-management/themes' />} />
    </Routes>
  );
};

export default ThemesPage;